import { colors } from '../component_library/styles/theme'

const priceRatings = ['expensive', 'overpriced', 'fair', 'good', 'super']

/**
 * Looks up the rating in the main theme and returns the hex color
 *
 * @param rating
 * @returns {null|string}
 */
export const getRatingColor = (rating: number): null | string => {
  if (rating < 1 || rating > 5) return null

  return colors[priceRatings[rating - 1]]
}

/**
 * Retrieves the name the price rating used for the theme color
 *
 * @param rating
 * @returns {string|null}
 */
export const getRatingColorName = (rating: number): null | string => {
  if (rating < 1 || rating > 5) return null

  return priceRatings[rating - 1]
}
